/**
 * GET /payment-errors — eager-load invoice + nested lead & author for listing.
 */
export const PAYMENT_ERROR_RELATIONS = 
[
  'invoice.order.lead',
  
  ];

export const buildPaymentErrorRelationParams = () =>
  PAYMENT_ERROR_RELATIONS.reduce((acc, rel, i) => {
    acc[`relations[${i}]`] = rel;
    return acc;
  }, {});
